/* eslint-disable react-hooks/exhaustive-deps */
import { get, isEmpty } from "lodash-es";
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { getAdminCompainesMyManagers } from "../../apis/admin/roles";
import {
  getCompainesManagers,
  getCompainesMyManagers,
} from "../../apis/companies/roles";
import { ControlTable } from "../../components/Table";
import MangerCompany from "./ManagerCompay";

const Managers = (props) => {
  const { targetCompany } = props;
  const { user, company, companies } = useSelector(
    (store) => ({
      user: store.Profile.user,
      company: store.Profile.company,
      companies: store.Data.companies,
    }),
    shallowEqual
  );
  const [myCompany, setMyCompany] = useState({});
  const [myCareCompany, setMyCareCompany] = useState({});
  const [fields] = useState([
    {
      title: "구분",
      key: "level",
      onTranslator: {
        list: [
          {
            label: "주담당자",
            value: 1,
          },
          {
            label: "담당자",
            value: 2,
          },
        ],
      },
    },
    { title: "성명", key: "managerName" },
    //{ title: "연락처", key: "managerMobile" },
    { title: "이메일", key: "managerEmail" },
  ]);
  const [masterCom, setMasterCom] = useState("");
  const [masterManagerList, setMasterManagerList] = useState([]);
  const [taxCom, setTaxCom] = useState("");
  const [taxManagerList, setTaxManagerList] = useState([]);
  const [laborCom, setLaborCom] = useState("");
  const [laborManagerList, setLaborManagerList] = useState([]);


  // 상세페이지
  const [open, setOpen] = useState(false);
  const [managerComList, setManagerComList] = useState([]);
  const [managerComType, setManagerComType] = useState(null);

  useEffect(() => {
    if (!isEmpty(user) && !isEmpty(companies)) {
      setMyCompany(
        companies.find((com) => com.companyIdx === user.managerCompanyIdx)
      );
    }

    if (!isEmpty(company)) {
      setMyCareCompany(company);
    }
  }, [user, companies, company]);

  useEffect(() => {
    submit();
  }, [targetCompany]);

  const submit = () => {
    if (targetCompany === null) return;


    (
      targetCompany && targetCompany.idx ?
        getAdminCompainesMyManagers(targetCompany.idx) :
        getCompainesMyManagers()
    )
      .then((res) => {
        setTaxManagerList(get(res, "data.taxCompany.managers"));
        const taxCom = get(res, "data.taxCompany.name");
        const taxPhone = get(res, "data.taxCompany.phone");
        if( !isEmpty(taxPhone) && taxPhone.length > 3) {
          setTaxCom(`${taxCom} [ 대표번호 : ${taxPhone} ]` );
        } else {
          setTaxCom(taxCom);
        }

        setLaborManagerList(get(res, "data.laborCompany.managers"));
        const laborCom = get(res, "data.laborCompany.name");
        const laborPhone = get(res, "data.laborCompany.phone");
        if( !isEmpty(laborPhone) && laborPhone.length > 3) {
          setLaborCom(`${laborCom} [ 대표번호 : ${laborPhone} ]` );
        } else {
          setLaborCom(laborCom);
        }

        setMasterManagerList(get(res, "data.masterCompany.managers"));
        const masterCom = get(res, "data.masterCompany.name");
        const masterPhone = get(res, "data.masterCompany.phone");
        if( !isEmpty(masterPhone) && masterPhone.length > 3) {
          setMasterCom(`${masterCom} [ 대표번호 : ${masterPhone} ]` );
        } else {
          setMasterCom(masterCom);
        }

      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const headerbutton = (type) => {
    let buttons = [];
    switch (type) {
      case 2:
        if (myCompany && myCompany.type !== 9) return;
        buttons = [
          {
            label: isEmpty(taxCom) ? "담당회사 등록" : "담당회사 변경",
            color: "line",
            size: "sm",
            action: () => {
              getMangerList(2);
            },
            className: "float-right",
          },
        ];
        break;
      case 3:
        if (myCompany && myCompany.type !== 9) return;
        buttons = [
          {
            label: isEmpty(laborCom) ? "담당회사 등록" : "담당회사 변경",
            color: "line",
            size: "sm",
            action: () => {
              getMangerList(3);
            },
            className: "float-right",
          },
        ];
        break;
      case 9:
        if (myCompany && myCompany.type !== 9) return;
        buttons = [
          {
            label: isEmpty(masterCom) ? "담당회사 등록" : "담당회사 변경",
            color: "line",
            size: "sm",
            action: () => {
              getMangerList(9);
            },
            className: "float-right",
          },
        ];
        break;
      default:
        break;
    }

    return buttons;
  };

  const getMangerList = (type) => {
    getCompainesManagers(type).then((res) => {
      setOpen(true);
      setManagerComList(res.data);
      setManagerComType(type);
    });
  };

  return (
    <>
      <div className="MyMangers">
        <div>
          <ControlTable
            fields={fields}
            list={taxManagerList}
            title={!isEmpty(taxCom) ? taxCom : "담당 세무사 정보"}
            buttons={headerbutton(2)}
          />
        </div>
        <div style={{ marginTop: "32px" }}>
          <ControlTable
            fields={fields}
            list={laborManagerList}
            title={!isEmpty(laborCom) ? laborCom : "담당 노무사 정보"}
            buttons={headerbutton(3)}
          />
        </div>
        {myCompany.type === 9 &&
          <div style={{ marginTop: "32px" }}>
            <ControlTable
              fields={fields}
              list={masterManagerList}
              title={!isEmpty(masterCom) ? masterCom : "담당 경리대행사 정보"}
              buttons={headerbutton(9)}
            />
          </div>
        }
      </div>
      <MangerCompany
        open={open}
        setOpen={setOpen}
        list={managerComList}
        type={managerComType}
        myCareCompany={targetCompany || myCareCompany}
        submit={submit}
      />
    </>
  );
};

export default Managers;
